export const LOADING_IMAGENES = "LOADING_IMAGENES";
export const GET_IMAGENES_SUCCESS = "GET_IMAGENES_SUCCESS";
export const GET_IMAGENES_FAILURE = "GET_IMAGENES_FAILURE";
export const SET_IMAGENES_PAGE = "SET_IMAGENES_PAGE";
export const RESET_IMAGENES = "RESET_IMAGENES";
